// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/SalesPages/CashOutModal.module.css */

:root {
  --green: rgba(24, 115, 70, 1);
  --green-2: rgba(29, 135, 82, 1);
  --border: rgba(229, 231, 235, 1);
  --bg: #ffffff;
  --muted: #6b7280;
  --text: #111827;
  --danger: rgba(220, 38, 38, 1);
}

.CashOutModal_modal__6\\+Gce {
  width: 900px;
  height: 600px;
  display: flex;
  overflow: hidden;
  border-radius: 16px;
  padding: 0;
}

.CashOutModal_left__zWAcT {
  flex: 0 0 40%;
  background: #f7faf8;
  padding: 20px;
  border-right: 1px solid var(--border);
}

.CashOutModal_right__mKXd1 {
  flex: 1 1;
  padding: 20px;
  background: var(--bg);
}

.CashOutModal_top__rrMuj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.CashOutModal_subTitle__VQJeP {
  font-size: 12px;
  color: var(--muted);
}

.CashOutModal_balance__9MsFu {
  font-size: 24px;
  font-weight: 900;
  color: var(--green);
  margin-top: 4px;
}

.CashOutModal_walletLine__jqD4i {
  font-size: 12px;
  color: #9aa0a6;
  margin-top: 6px;
}

.CashOutModal_quickGrid__9PJMk {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}

.CashOutModal_quickBtn__gVxSz {
  padding: 14px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 800;
  transition: 0.15s ease;
}

.CashOutModal_quickBtn__gVxSz:hover {
  border-color: rgba(24, 115, 70, 0.35);
  box-shadow: 0 6px 18px rgba(24, 115, 70, 0.12);
}

.CashOutModal_pad__KDPQM {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.CashOutModal_keyBtn__n4zAN {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: #fff;
  cursor: pointer;
  font-size: 22px;
  font-weight: 900;
  transition: 0.15s ease;
}

.CashOutModal_keyBtn__n4zAN:hover {
  border-color: rgba(24, 115, 70, 0.35);
  box-shadow: 0 6px 18px rgba(24, 115, 70, 0.12);
}

.CashOutModal_clearBtn__dMogn {
  margin-top: 12px;
  grid-column: 1 / -1;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(220, 38, 38, 0.2);
  background: rgba(220, 38, 38, 0.08);
  cursor: pointer;
  font-size: 18px;
  font-weight: 900;
  color: var(--danger);
}

.CashOutModal_form__9cMus {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.CashOutModal_field__JWSjI {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.CashOutModal_label__d4V3U {
  font-size: 13px;
  font-weight: 800;
  color: var(--text);
}

.CashOutModal_amountInputWrap__JHbR9 {
  display: flex;
  align-items: center;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px 12px;
  transition: 0.15s ease;
}

.CashOutModal_amountInputWrap__JHbR9:focus-within {
  border-color: rgba(24, 115, 70, 0.5);
  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);
}

.CashOutModal_amountInput__Q5gTm {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: var(--text);
  background: transparent;
}

.CashOutModal_currency__bQJQF {
  font-weight: 900;
  color: var(--green);
}

.CashOutModal_select__S86D9 {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  border: 1px solid var(--border);
  padding: 0 12px;
  outline: none;
  font-weight: 700;
  transition: 0.15s ease;
}

.CashOutModal_select__S86D9:focus {
  border-color: rgba(24, 115, 70, 0.5);
  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);
}

.CashOutModal_textarea__To4JW {
  width: 100%;
  min-height: 92px;
  border-radius: 12px;
  border: 1px solid var(--border);
  padding: 12px;
  outline: none;
  resize: none;
  font-weight: 600;
  transition: 0.15s ease;
}

.CashOutModal_textarea__To4JW:focus {
  border-color: rgba(24, 115, 70, 0.5);
  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);
}

.CashOutModal_counter__9ilMp {
  font-size: 12px;
  color: #9aa0a6;
}

.CashOutModal_actions__EuiOc {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 10px;
}

.CashOutModal_cancelBtn__EhjG7 {
  height: 44px;
  padding: 0 22px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: #fff;
  cursor: pointer;
  font-weight: 800;
  transition: 0.15s ease;
}

.CashOutModal_cancelBtn__EhjG7:hover {
  border-color: rgba(24, 115, 70, 0.35);
}

.CashOutModal_primaryBtn__GBKXO {
  height: 44px;
  padding: 0 22px;
  border-radius: 12px;
  border: none;
  background: var(--green);
  color: #fff;
  cursor: pointer;
  font-weight: 900;
  transition: 0.15s ease;
}

.CashOutModal_primaryBtn__GBKXO:hover {
  background: var(--green-2);
  box-shadow: 0 8px 22px rgba(24, 115, 70, 0.18);
}

.CashOutModal_primaryBtn__GBKXO:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/CashOutModal.module.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* src/pages/SalesPages/CashOutModal.module.css */\n\n:root {\n  --green: rgba(24, 115, 70, 1);\n  --green-2: rgba(29, 135, 82, 1);\n  --border: rgba(229, 231, 235, 1);\n  --bg: #ffffff;\n  --muted: #6b7280;\n  --text: #111827;\n  --danger: rgba(220, 38, 38, 1);\n}\n\n.modal {\n  width: 900px;\n  height: 600px;\n  display: flex;\n  overflow: hidden;\n  border-radius: 16px;\n  padding: 0;\n}\n\n.left {\n  flex: 0 0 40%;\n  background: #f7faf8;\n  padding: 20px;\n  border-right: 1px solid var(--border);\n}\n\n.right {\n  flex: 1;\n  padding: 20px;\n  background: var(--bg);\n}\n\n.top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.subTitle {\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.balance {\n  font-size: 24px;\n  font-weight: 900;\n  color: var(--green);\n  margin-top: 4px;\n}\n\n.walletLine {\n  font-size: 12px;\n  color: #9aa0a6;\n  margin-top: 6px;\n}\n\n.quickGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.quickBtn {\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: #fff;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 800;\n  transition: 0.15s ease;\n}\n\n.quickBtn:hover {\n  border-color: rgba(24, 115, 70, 0.35);\n  box-shadow: 0 6px 18px rgba(24, 115, 70, 0.12);\n}\n\n.pad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.keyBtn {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: #fff;\n  cursor: pointer;\n  font-size: 22px;\n  font-weight: 900;\n  transition: 0.15s ease;\n}\n\n.keyBtn:hover {\n  border-color: rgba(24, 115, 70, 0.35);\n  box-shadow: 0 6px 18px rgba(24, 115, 70, 0.12);\n}\n\n.clearBtn {\n  margin-top: 12px;\n  grid-column: 1 / -1;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(220, 38, 38, 0.2);\n  background: rgba(220, 38, 38, 0.08);\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 900;\n  color: var(--danger);\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.label {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--text);\n}\n\n.amountInputWrap {\n  display: flex;\n  align-items: center;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 10px 12px;\n  transition: 0.15s ease;\n}\n\n.amountInputWrap:focus-within {\n  border-color: rgba(24, 115, 70, 0.5);\n  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);\n}\n\n.amountInput {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 16px;\n  color: var(--text);\n  background: transparent;\n}\n\n.currency {\n  font-weight: 900;\n  color: var(--green);\n}\n\n.select {\n  width: 100%;\n  height: 44px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  padding: 0 12px;\n  outline: none;\n  font-weight: 700;\n  transition: 0.15s ease;\n}\n\n.select:focus {\n  border-color: rgba(24, 115, 70, 0.5);\n  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);\n}\n\n.textarea {\n  width: 100%;\n  min-height: 92px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  padding: 12px;\n  outline: none;\n  resize: none;\n  font-weight: 600;\n  transition: 0.15s ease;\n}\n\n.textarea:focus {\n  border-color: rgba(24, 115, 70, 0.5);\n  box-shadow: 0 0 0 4px rgba(24, 115, 70, 0.12);\n}\n\n.counter {\n  font-size: 12px;\n  color: #9aa0a6;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.cancelBtn {\n  height: 44px;\n  padding: 0 22px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: #fff;\n  cursor: pointer;\n  font-weight: 800;\n  transition: 0.15s ease;\n}\n\n.cancelBtn:hover {\n  border-color: rgba(24, 115, 70, 0.35);\n}\n\n.primaryBtn {\n  height: 44px;\n  padding: 0 22px;\n  border-radius: 12px;\n  border: none;\n  background: var(--green);\n  color: #fff;\n  cursor: pointer;\n  font-weight: 900;\n  transition: 0.15s ease;\n}\n\n.primaryBtn:hover {\n  background: var(--green-2);\n  box-shadow: 0 8px 22px rgba(24, 115, 70, 0.18);\n}\n\n.primaryBtn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `CashOutModal_modal__6+Gce`,
	"left": `CashOutModal_left__zWAcT`,
	"right": `CashOutModal_right__mKXd1`,
	"top": `CashOutModal_top__rrMuj`,
	"subTitle": `CashOutModal_subTitle__VQJeP`,
	"balance": `CashOutModal_balance__9MsFu`,
	"walletLine": `CashOutModal_walletLine__jqD4i`,
	"quickGrid": `CashOutModal_quickGrid__9PJMk`,
	"quickBtn": `CashOutModal_quickBtn__gVxSz`,
	"pad": `CashOutModal_pad__KDPQM`,
	"keyBtn": `CashOutModal_keyBtn__n4zAN`,
	"clearBtn": `CashOutModal_clearBtn__dMogn`,
	"form": `CashOutModal_form__9cMus`,
	"field": `CashOutModal_field__JWSjI`,
	"label": `CashOutModal_label__d4V3U`,
	"amountInputWrap": `CashOutModal_amountInputWrap__JHbR9`,
	"amountInput": `CashOutModal_amountInput__Q5gTm`,
	"currency": `CashOutModal_currency__bQJQF`,
	"select": `CashOutModal_select__S86D9`,
	"textarea": `CashOutModal_textarea__To4JW`,
	"counter": `CashOutModal_counter__9ilMp`,
	"actions": `CashOutModal_actions__EuiOc`,
	"cancelBtn": `CashOutModal_cancelBtn__EhjG7`,
	"primaryBtn": `CashOutModal_primaryBtn__GBKXO`
};
export default ___CSS_LOADER_EXPORT___;
